module.exports = __webpack_public_path__ + "img/symbol_8.ef003f9a.png";